var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.558 2.308h-3.173V1.73C10.385.776 9.608 0 8.654 0H6.346c-.954 0-1.73.776-1.73 1.73v.578H1.441C.647 2.308 0 2.955 0 3.75v2.02c0 .318.258.576.577.576h.315l.499 10.467c.044.924.803 1.649 1.728 1.649h8.762c.925 0 1.684-.725 1.728-1.649l.499-10.467h.315c.319 0 .577-.258.577-.577V3.75c0-.795-.647-1.442-1.442-1.442zM5.769 1.73c0-.318.26-.577.577-.577h2.308c.318 0 .577.259.577.577v.577H5.769V1.73zM1.154 3.75c0-.16.13-.288.288-.288h12.116c.159 0 .288.129.288.288v1.442H1.154V3.75zm11.303 13.008c-.015.308-.268.55-.576.55H3.119c-.308 0-.561-.242-.576-.55L2.047 6.346h10.906l-.496 10.412z",
    transform: "translate(-1390 -484) translate(1390 484)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16.154c.319 0 .577-.258.577-.577v-7.5c0-.319-.258-.577-.577-.577-.319 0-.577.258-.577.577v7.5c0 .319.258.577.577.577zM10.385 16.154c.318 0 .577-.258.577-.577v-7.5c0-.319-.259-.577-.577-.577-.319 0-.577.258-.577.577v7.5c0 .319.258.577.577.577zM4.615 16.154c.319 0 .577-.258.577-.577v-7.5c0-.319-.258-.577-.577-.577-.318 0-.577.258-.577.577v7.5c0 .319.259.577.577.577z",
    transform: "translate(-1390 -484) translate(1390 484)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.6144a75e01728567915b1bd78a43425e.svg";
export { ForwardRef as ReactComponent };